import * as React from "react";

var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgJo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-jo",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M-117.8 0h682.6v512h-682.6z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(110.5) scale(.9375)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.8 0h1024v170.7h-1024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-117.8 170.7h1024v170.6h-1024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M-117.8 341.3h1024V512h-1024z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "m-117.8 512 512-256-512-256v512z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m24.5 289 5.7-24.9H4.7l23-11-15.9-19.9 23 11 5.6-24.8 5.7 24.9L69 233.2l-16 19.9 23 11H50.6l5.7 24.9-15.9-20z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJo);
export default ForwardRef;
export { ForwardRef as ReactComponent };